import React from "react";

import Container from "../share/Container/Container";
import Button from "../share/Button/Button";
import { career } from "../../config/career";
import "./CareerTeaser.scss";

// Hinweis auf die offene Stelle, eingebunden auf "Über uns".
// Inhalt & An/Aus kommen aus src/config/career.ts (Feld `teaser`).
const CareerTeaser = () => {
  const { teaser, hero } = career;

  if (!teaser || !teaser.enabled) return null;

  return (
    <section className="CareerTeaser" aria-label="Stellenangebot">
      <Container variant={["no-top", "no-bottom"]}>
        <div className="CareerTeaser__wrapper">
          <div className="CareerTeaser__image">
            <img src={hero.poster} alt={hero.posterAlt} loading="lazy" />
          </div>
          <div className="CareerTeaser__content">
            <span className="CareerTeaser__eyebrow">{teaser.eyebrow}</span>
            <h2 className="CareerTeaser__title">{teaser.title}</h2>
            <p
              className="CareerTeaser__text"
              dangerouslySetInnerHTML={{ __html: teaser.text }}
            />
            <div className="CareerTeaser__cta">
              <Button variant="dark" link="/karriere" label={teaser.ctaLabel} />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CareerTeaser;
